let federationMounted = false;

export function markFederationMount(isFederated = true): void {
  federationMounted = isFederated;
}

export function isFederated(): boolean {
  return federationMounted;
}
